import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlotsListComponent } from './plots-list/plots-list.component';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    PlotsListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
})
export class PlotsModule { }
